// Hooks (@tanstack/react-query) imports
import { useMutation } from "@tanstack/react-query";

// Configs imports
import api from "../../app/api";

// Custom types imports
import { ApiErrorResponse } from "apisauce";
import { Person } from "./types";

interface paramsType {
  idCard: string;
  notificationID: string | number;
}

export function usePersonByIdCardMutation(
  onSuccessMutation?: (data: Person, variables: paramsType) => void,
  onErrorMutation?: (err: ApiErrorResponse<any>, variables: paramsType) => void
) {
  async function personByIdCard(params: paramsType): Promise<Person> {
    const response = await api.get<Person>(
      `admin/persons/byidcard/${params.idCard}`
    );

    if (!response.ok || !response.data) {
      throw response;
    }

    return response.data;
  }

  return useMutation({
    mutationFn: personByIdCard,
    onSuccess: onSuccessMutation,
    onError: onErrorMutation,
  });
}
